<template>
  <div>
    <!-- Content Header (Page header) -->
   
    <!-- Main content -->
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseCollectionCenter(branch, withChangeFilter = true)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="canAccess('collection-center-create')">
              <label for="Branch">Group</label>
              <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="colCenters" placeholder="Select Group" v-on:input="getRecordByCollectionCenter" required></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-3">
              <button class="btn btn-info" @click="printViewDisbursementByCollectionCenter(status = 'pending')">Get Print</button>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <span class="pull-right">
                <strong>Total amt: {{totalAmt}}</strong>
                <button type="button" v-if="canAccess('loan-disbursement-create-loan')" class="btn btn-success" @click="newModal">
                  <i class="fa fa-plus"></i>
                </button>
              </span>
              <h3 class="card-title">Group Loan</h3>
            </div>
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :line-numbers="true"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'plan_name'">
                    {{ planName(props.row.plan) }}
                  </span>
                  <span v-if="props.column.field == 'plan_amt'">
                    <b v-if="props.row.loanAmount">{{props.row.loanAmount}}</b>
                    <b v-else>{{ planAmt(props.row.plan) }}</b>
                  </span>
                  <span v-if="props.column.field == 'member_name'">
                    <button v-if="props.row.member"
                    @click="viewGroupMemberDetail(props.row.member_id)"
                    class="btn btn-xs btn-info" >
                    {{props.row.member.name}}
                    </button>
                  </span>
                  <span v-if="props.column.field == 'Status'">
                    <span
                      v-if="props.row.status == 'pending'"
                      class="label label-warning"
                      >Pending</span
                    >
                    <span
                      v-if="props.row.status == 'disbursed'"
                      class="label label-success"
                      >Disbursed</span
                    >
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button
                      v-if="canAccess('loan-disbursement-update')"
                      v-show="props.row.status == 'pending'"
                      @click="editModal(props.row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      v-show="props.row.status == 'disbursed' || props.row.status == 'pending'"
                      @click="deleteDisbursment(props.row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-show="props.row.filechargeStatus == 'exclude'"
                      @click="fileChargeModal(props.row)"
                      class="btn btn-warning btn-xs"
                      title="File Charge"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-show="props.row.processingFeeStatus == 'exclude'"
                      @click="processingFeeModal(props.row)"
                      class="btn btn-warning btn-xs"
                      title="Processing Fee"
                    >
                      <i class="fa fa-hourglass"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-create')"
                      v-show="props.row.status == 'pending'"
                      @click="disbursmentModal(props.row)"
                      class="btn btn-danger btn-xs"
                      title="Disbursed"
                    >
                      <i class="fa fa-money"></i>
                    </button>
                    <button
                      v-if="props.row.status == 'pending'"
                      @click="viewModal(props.row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      
                      @click="viewPrintModal(props.row)"
                      class="btn btn-primary btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div> -->
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Group Loan List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('loan-disbursement-create-loan')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th class="hidden-xs">Pl Name</th>
                <th class="hidden-xs">Pl Emi Type</th>
                <th>Pay Amt</th>
                <th>Member</th>
                <!-- <th class="hidden-xs">Type</th> -->
                <th class="hidden-xs">Mem Code</th>
                <th>Group</th>
                <th class="hidden-xs">Staff</th>
                <th class="hidden-xs">Branch Name</th>
                <th class="hidden-xs">Branch code</th>
                <th class="hidden-xs">Center Leader</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td class="hidden-xs">{{ planName(row.plan) }}</td>
                <td class="hidden-xs">{{ planRecoveryType(row.plan) }}</td>
                <td>{{ planAmt(row) }}</td>
                <td><button v-if="row.member"
                    @click="viewGroupMemberDetail(row.member_id)"
                    class="btn btn-xs btn-info" >
                    {{row.member.name}}
                    </button>
                </td>
                <!-- <td class="hidden-xs">{{row.planType}}</td> -->
                <td class="hidden-xs"><span v-if="row.member">{{row.member.code}}</span></td>
                <td>{{row.collection_center.name}}</td>
                <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.branch.branchCode }}</td>
                <td class="hidden-xs">{{row.collection_center_leader.name}}</td>
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('loan-disbursement-update')"
                      v-show="row.status == 'pending'"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      v-show="row.status == 'disbursed' || row.status == 'pending'"
                      @click="deleteDisbursment(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-show="row.filechargeStatus == 'exclude'"
                      @click="fileChargeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="File Charge"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-show="row.processingFeeStatus == 'exclude'"
                      @click="processingFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Processing Fee"
                    >
                      <i class="fa fa-hourglass"></i>
                    </button>
                    <button
                      v-show="row.insuranceFeeStatus == 'exclude'"
                      @click="insuranceFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Insurance Fee"
                    >
                      <i class="fa fa-user-md"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-create')"
                      v-show="row.status == 'pending'"
                      @click="disbursmentModal(row)"
                      class="btn btn-danger btn-xs"
                      title="Disbursed"
                    >
                      <i class="fa fa-money"></i>
                    </button>
                    <!-- <button
                      v-if="row.status == 'pending'"
                      @click="viewModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button> -->
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      
                      @click="viewPrintModal(row)"
                      class="btn btn-primary btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Dimand ProbeshnaryNote"
                      @click="viewPrintDimandProbeshnoryNote(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-sticky-note-o"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Create New Loan</h4>
              <h4 v-show="editMode" class="modal-title">Update Loan</h4>
            </div>
            <form @submit.prevent="editMode ? updateLoan() : createLoan()">
              <div class="modal-body">
               
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group" v-if="userType === 'admin'">
                            <label>Branch <span class="red">*</span></label>
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                              @change="getMemberAndGroupAndAgent"
                              required
                            >
                              <option v-if="!form.branch_id" selected value="">
                                Select branch
                              </option>
                              <option
                                :value="bra.id"
                                v-for="bra in branches"
                                :key="bra.id"
                              >
                                {{ bra.name }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Agent ID <span class="red">*</span></label>
                            <!-- <select
                              v-model="form.agent_id"
                              name="agent_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('agent_id'),
                              }"
                            >
                              <option v-if="!form.agent_id" selected value="">
                                Select Agent
                              </option>
                              <option
                                :value="staf.user_id"
                                v-for="staf in staffs"
                                :key="staf.id"
                              >
                                {{ staf.user.name }} - {{ staf.user.code }}
                              </option>
                            </select> -->
                            <v-select v-model="staf" name="agent_id" label="name" :options="staffs" placeholder="Select Agent" v-on:input="getBranchAgent" required>

                            </v-select>
                            <has-error
                              :form="form"
                              field="agent_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Group </label>
                            
                            <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="getBranchCollectionCenter" required>
                              
                            </v-select>
                            <has-error
                              :form="form"
                              field="collection_center_id"
                            ></has-error>
                          </div>
                          <div
                            class="form-group"
                          >
                            <label
                              >Group Leader <span class="red">*</span></label
                            >
                            <v-select v-model="centerLeader" name="center_leader_id" label="name" :options="groupMembers" placeholder="Select Group Leader" v-on:input="getCenterLeader" required>
                            </v-select>
                            <has-error
                              :form="form"
                              field="center_leader_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Purpose <span class="red">*</span></label>
                            <v-select v-model="form.purpose" name="purpose" label="name" placeholder="Select purpose" :options="purposes" v-on:input="getSelectPurpose"></v-select>
                            <has-error :form="form" field="purpose_id"></has-error>
                            <input
                              type="hidden"
                              name="purpose_id"
                              v-model="form.purpose_id"
                            />
                          </div>
                          <!-- text input -->
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Plan <span class="red">*</span></label>
                            <select
                              v-model="form.plan"
                              name="plan"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('plan') }"
                              @change="getSelectPlan"
                              required
                            >
                              <option v-if="!form.plan" selected value="">
                                Select Plan
                              </option>
                              <option
                                :value="loanpl"
                                v-for="loanpl in loanplans"
                                :key="loanpl.id"
                              >
                                {{ loanpl.name }}
                              </option>
                            </select>
                            <has-error :form="form" field="plan_id"></has-error>
                            <input
                              type="hidden"
                              name="plan_id"
                              v-model="form.plan_id"
                            />
                          </div>
                          <div class="form-group">
                            <label
                              >Description<span class="red">*</span></label
                            >
                            <input
                              v-model="form.description"
                              type="text"
                              name="description"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('description'),
                              }"
                              placeholder="Enter Description"
                            />
                            <has-error
                              :form="form"
                              field="description"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="planTypeApplied == 'active'">
                            <label
                              >Loan Amount Type <span class="red">*</span></label
                            >
                            <select
                              v-model="form.loanAmountType"
                              name="loanAmountType"
                               @change="changeLoanAmountType"
                              class="form-control"
                             
                              :class="{
                                'is-invalid': form.errors.has('loanAmountType'),
                              }"
                            >
                              <option value="">Select Loan Amount Type</option>
                              <option value="static">Static</option>
                              <option value="dynamic">Dynamic</option>
                            </select>
                            <has-error :form="form" field="loanAmountType"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Member <span class="red">*</span></label>
                            <v-select v-model="mem"  name="member_id" label="name" :options="groupMembers" placeholder="Select Member" v-on:input="getBranchMember">
                              
                            </v-select>
                            
                            <has-error
                              :form="form"
                              field="member_id"
                            ></has-error>
                          </div>
                          
                          <div class="form-group">
                            <label>Guarantor </label>
                            <v-select v-model="guarantor"  name="guarantor_id" label="name" :options="members" placeholder="Select Member" v-on:input="getLoanGuarantor">
                              
                            </v-select>
                            
                            <has-error
                              :form="form"
                              field="guarantor_id"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic'">
                            <label>Loan Amount <span class="red">*</span></label>
                            <input
                              v-model="form.loanAmount"
                              type="text"
                              name="loanAmount"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('loanAmount'),
                              }"
                              placeholder="Enter Customer loanAmount"
                            />
                            <has-error
                              :form="form"
                              field="loanAmount"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic'">
                            <label>File Charge Amount <span class="red">*</span></label>
                            <input
                              v-model="form.fileCharge"
                              type="text"
                              name="fileCharge"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fileCharge'),
                              }"
                              placeholder="Enter Customer fileCharge"
                            />
                            <has-error
                              :form="form"
                              field="fileCharge"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && processingFeeType == 'fixed'">
                            <label>Processing Fee Amount <span class="red">*</span></label>
                            <input
                              v-model="form.processingFee"
                              type="text"
                              name="processingFee"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFee'),
                              }"
                              placeholder="Enter Customer processingFee"
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && processingFeeType == 'percent'">
                            <label>Processing Fee Amount %<span class="red">*</span></label>
                            <!-- <input
                              v-model="form.processingFee"
                              type="text"
                              name="processingFee"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFee'),
                              }"
                              placeholder="Enter Customer processingFee"
                            /> -->
                            <input
                              v-model="form.processingFee"
                              type="number"
                              step=".01"
                              name="processingFee"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFeePer'),
                              }"
                              placeholder="Enter Customer processingFee"
                              readonly
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <!-- <div class="form-group">
                              <label>Select Status <span class="red">*</span></label>
                              <select v-model="form.status" name="status"
                                  class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                  <option v-if="!form.status" selected value="">Select Status</option>
                                  <option value="active">Active</option>
                                  <option value="inActive">Inactive</option>
                                  
                              </select>
                              <has-error :form="form" field="status"></has-error>
                            </div> -->
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="disbursmentModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Disbursement Loan</h4>
            </div>
            <form @submit.prevent="createDisbursement()">
              <div class="modal-body">
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>
                              Disbursement Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.disbursementDate"
                              type="date"
                              name="disbursementDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'disbursementDate'
                                ),
                              }"
                              placeholder="Enter joining Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="disbursementDate"
                            ></has-error>
                            <input
                              type="hidden"
                              name="disbursement_id"
                              v-model="form.disbursement_id"
                            />
                          </div>

                          <div class="form-group">
                            <label
                              >EMI Start Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.emiStartDate"
                              type="date"
                              name="emiStartDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('emiStartDate'),
                              }"
                              placeholder="Enter joining Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="emiStartDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>

                          <!-- <div class="form-group">
                              <label>Select Status <span class="red">*</span></label>
                              <select v-model="form.status" name="status"
                                  class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                  <option v-if="!form.status" selected value="">Select Status</option>
                                  <option value="active">Active</option>
                                  <option value="inActive">Inactive</option>
                                  
                              </select>
                              <has-error :form="form" field="status"></has-error>
                            </div> -->
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  DISBURSEMENT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="fileChargeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">File Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect File Charge </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="processingFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Processing Fee Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Processing Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <view-loan-plan :seeRecord="this.seeRecord" :pl="this.pl" :memberDetail="this.memberDetail" :getCompanyRecord="this.getCompanyRecord" :logo="this.logo"></view-loan-plan>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Loan Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr>
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                              </td>
                              <td>
                                <!-- <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }} -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td>
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_id">
                          <b>Member Name</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b>
                          <a class="pull-right">{{ seeRecord.paymentMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewGroupMember">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Group Member Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>C/O</th>
                              <th>Address</th>
                              <th>City</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="groupmem">
                              <td>
                                {{ groupmem.fatherName }}
                              </td>
                              <td>
                                {{ groupmem.address}}
                              </td>
                              <td>
                                {{groupmem.city}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- Demand Probeshnary note  -->
      <demandprobeshnarynote :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></demandprobeshnarynote>
      <!-- /.modal -->
      <printviewdisbursementcollectioncenterwise :seeRecords="this.seeRecords" :branch="branch" :collectionCenter="collectionCenter" :getCompanyRecord="getCompanyRecord" :logo="logo"></printviewdisbursementcollectioncenterwise>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import demandprobeshnarynote from '../components/DemandProbeshnaryNote.vue'
import BranchWiseCollectionCenter from '../../mixins/BranchWiseCollectionCenterData'
import DisbursementByCollectionCenter from '../../mixins/DisbursementByCollectionCenter'
import printviewdisbursementcollectioncenterwise from '../components/PrintViewDisbursementCollectionCenterWise.vue'
import VueBarcode from 'vue-barcode'
import VueLoanPlan from './ViewLoan.vue'
export default {
  name: 'groupLoan',
  mixins: [BranchWiseCollectionCenter, DisbursementByCollectionCenter],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      totalAmt: 0,
      planTypeApplied: 'inActive',
      userType: '',
      logo: '',
      mem: {},
      guarantor: {},
      groupmem: {},
      memberDetail: {},
      collectionCenters: [],
      collectionCenter: {},
      centerLeader: {},
      colC: {},
      branches: [],
      branch: {},
      members: [],
      staffs: [],
      staf: {},
      bank_accounts: [],
      pl: {},
      seeRecord: {},
      loanplans: [],
      purposes: [],
      groupMembers: [],
      processingFeeType: '',
      insuranceFeeType: '',
      getCompanyRecord: {},
      viewCollectionCenter: '',
      getSettingRecord: '',
      userStatus: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: null,
        guarantor_id: null,
        branch_id: '',
        agent_id: '',
        loanAmount: null,
        loanAmountType: '',
        center_leader_id: '',
        plan_id: '',
        plan: {},
        planType: 'group',
        status: '',
        purpose: {},
        purpose_id: '',
        description: '',
        branch_ledger_id: '',
        disbursement_id: '',
        disbursementDate: new Date().toISOString().slice(0, 10),
        emiStartDate: '',
        amt: '',
        type: '',
        processingFee: null,
        fileCharge: null,
        paymentDate: null
      }),
      columns: [
        {
          label: 'PLAN Name',
          field: 'plan_name'
        },
        {
          label: 'PAY AMOUNT',
          field: 'plan_amt'
        },
        {
          label: 'MEMBER',
          field: 'member_name'
        },
        {
          label: 'TYPE',
          field: 'planType'
        },
        {
          label: 'GROUP',
          field: 'collection_center.name'
        },
        {
          label: 'AGENT',
          field: 'agent.name'
        },
        {
          label: 'BRANCH NAME',
          field: 'branch.name'
        },
        {
          label: 'CENTER LEADER',
          field: 'collection_center_leader.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  components: {
    'barcode': VueBarcode,
    'view-loan-plan': VueLoanPlan,
    printviewdisbursementcollectioncenterwise,
    demandprobeshnarynote
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getSelectPurpose () {
      this.form.purpose_id = ''
      this.form.purpose_id = this.form.purpose.id
    },
    newModal () {
      var c = JSON.parse(localStorage.user)
      this.userType = c.type
      this.colC = {}
      this.centerLeader = {}
      this.form.branch_id = null
      this.user = this.$store.state.user
      this.editMode = false
      this.form.loanAmountType = ''
      this.planTypeApplied = 'inActive'
      this.members = []
      this.guarantor = {}
      this.staffs = []
      this.staf = {}
      this.groupMembers = []
      this.mem = {}
      this.form.reset()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      if (c.type === 'staff') {
        this.form.branch_id = c.agent_profile.branch_id
        this.getMemberAndGroupAndAgent()
      }
    },
    getRecordByCollectionCenter (collectionCenter) {
      this.form.collection_center_id = ''
      this.form.collection_center_id = collectionCenter.id
      this.form.branch_id = collectionCenter.branch_id
      this.changeFilter()
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    // planAmt (plan) {
    //   var pln = JSON.parse(plan)
    //   return pln.amount
    // },
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    viewPrintDimandProbeshnoryNote (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintDimandProbeshnoryNote').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberDetail = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewGroupMemberDetail (id) {
      this.groupmem = {}
      this.$axios
        .get('member?all=all&user_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupmem = data.data[0]
        })
        .catch(function (error) { console.log(error) })
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    getCenterLeader () {
      this.form.center_leader_id = this.centerLeader.member_id
    },
    deleteDisbursment (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('disbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewGroupMember (id) {
      this.loadGroupMember(id)
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    changeLoanAmountType () {
      if (this.form.loanAmountType === 'static') {
        this.form.loanAmount = null
        this.form.fileCharge = null
        this.form.processingFee = null
      } else if (this.form.loanAmountType === 'dynamic') {
        this.form.loanAmount = this.form.plan.amount
        this.form.fileCharge = this.form.plan.fileCharge
        this.form.processingFee = this.form.plan.processingFee
      }
    },
    getBranchMember () {
      this.form.member_id = this.mem.member_id
    },
    getLoanGuarantor () {
      this.form.guarantor_id = this.guarantor.user_id
    },
    getBranchCollectionCenter () {
      this.form.collection_center_id = this.colC.id
      this.loadGroupMember(this.form.collection_center_id)
    },
    getBranchAgent () {
      this.form.agent_id = this.staf.user_id
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      return pl.amount
    },
    showPlanAmtReduced (pl) {
      return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    // processingFeeCollect () {
    //   if (this.form.planType === 'individual') {
    //     this.$delete(this.form, 'collection_center_id')
    //     this.$delete(this.form, 'center_leader_id')
    //   }
    //   this.$axios
    //     .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then(() => {
    //       Fire.$emit('AfterCreate')
    //       $('#processingFeeModal').modal('hide')
    //       Toast.fire({
    //         icon: 'success',
    //         title: 'Processing Fee Paid Successfully'
    //       })
    //     })
    // },

    createLoan () {
      this.$axios
        .post('createloan', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Create New Loan Successfully'
          })
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    disbursmentModal (row) {
      this.form.reset()
      $('#disbursmentModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    fileChargeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#fileChargeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'fileCharge'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.includeGst === 'true') {
        this.form.amt = row.fileCharge ? row.fileCharge + (row.fileCharge * 18 / 100) : this.pl.fileCharge + (this.pl.fileCharge * 18 / 100)
      } else {
        this.form.amt = row.fileCharge ? row.fileCharge : this.pl.fileCharge
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    processingFeeModal (row) {
      var pfamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#processingFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'processingFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (this.pl.processingFee * row.loanAmount / 100) : (this.pl.processingFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      if (this.pl.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : this.pl.processingFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    insuranceFeeModal (row) {
      var ifamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#insuranceFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'insuranceFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (this.pl.insuranceFee * row.loanAmount / 100) : (this.pl.insuranceFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      if (this.pl.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : this.pl.insuranceFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    // file charge and processing fee collection
    fileChargeProcessingFeeCollect () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.disbursementStartDate = ''
          this.form.disbursementEndDate = ''
          this.form.startEmiEndDate = ''
          this.form.endEmiEndDate = ''
          this.form.branch_id = ''
          this.changeFilter()
          if (this.form.type === 'fileCharge') {
            $('#fileChargeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'File Charge Paid Successfully'
            })
          }
          if (this.form.type === 'processingFee') {
            $('#processingFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Processing Fee Paid Successfully'
            })
          }
          $('#fileChargeModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'File Charge Paid Successfully'
          })
        })
    },
    getBranchBankAccount (id) {
      this.$axios
        .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    createDisbursement () {
      // if (this.form.planType === 'group') {
      //   this.$delete(this.form, 'member_id')
      // }
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      // if (this.form.paymentMode === 'cash') {
      //   this.$delete(this.form, 'bank_id')
      //   this.$delete(this.form, 'bank_account_id')
      // }
      this.$axios
        .post('disbursement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#disbursmentModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'New Loan Disbursed Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: error.response.data.error })
            this.form.errors.errors = error.response.data.error
            console.log(error.response.data.error)
          }.bind(this)
        )
    },
    editModal (row) {
      // console.log(row)
      this.editMode = true
      this.form.reset()
      this.form.fill(row)
      if (this.form.loanAmount != null) {
        this.form.loanAmountType = 'dynamic'
      } else {
        this.form.loanAmountType = 'static'
      }
      // this.form.plan = JSON.parse(row.plan)
      this.getMemberAndGroupAndAgent()
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      if (row.planType === 'group') {
        this.loadGroupMember(this.form.collection_center_id)
      }
      this.form.plan = _.find(this.loanplans, function (o) {
        return o.id === row.plan_id
      })
      // console.log(this.form.plan)
    },

    updateLoan () {
      // console.log('update data')
      // if (this.form.planType === 'group') {
      //   this.$delete(this.form, 'member_id')
      // }
      if (this.form.planType === 'individual') {
        // alert('hello')
        this.$delete(this.form, 'center_leader_id')
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .put('disbursement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Loan Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')

              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
      this.form.loanAmount = this.form.plan.amount
      this.form.fileCharge = this.form.plan.fileCharge
      this.form.processingFee = this.form.plan.processingFee
      this.processingFeeType = this.form.plan.processingFeeType
      if (this.form.plan.planType === 'normal' || this.form.plan.planType === 'normalReduced') {
        this.planTypeApplied = 'active'
      } else {
        this.planTypeApplied = 'inActive'
        this.form.loanAmountType = 'static'
      }
    },
    getPlanType () {
      this.form.center_leader_id = null
      this.form.collection_center_id = null
      this.form.member_id = null
    },
    getMemberAndGroupAndAgent () {
      var c = JSON.parse(localStorage.user)
      this.userStatus = ''
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      this.$axios
        .get('collectioncenter?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
            if (this.form.collection_center_id === item.id) {
              this.colC = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      if (c.type === 'staff') {
        if (c.role.name === 'Manager') {
          this.loadStaff()
        } else {
          this.staf = this.user.agent_profile
          this.staf.name = this.user.name + ' (' + this.user.code + ')'
          this.form.agent_id = this.staf.user_id
        }
      } else {
        this.loadStaff()
      }
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.staf = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadLoan () {
      this.$axios
        .get('loanplan?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadPurpose () {
      this.$axios
        .get('purpose?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.purposes = data.data
          $.each(this.purposes, function (key, value) {
            this.purposes[key].name = value.purpose
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
          _.forEach(this.groupMembers, function (item, key) {
            this.groupMembers[key].name = item.member.name + ' (' + item.member.code + ')'
            if (this.form.center_leader_id === item.member.id) {
              this.centerLeader = item
            }
            if (this.form.member_id === item.member.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    planRecoveryType (plan) {
      var pln = JSON.parse(plan)
      return pln.recoveryType
    },
    changeFilter (page = null, pg = null) {
      let loader = this.$loading.show()
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'disbursement'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      this.$axios
        .get(`${pageUrl}&status=pending&searchTerm=group`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          loader.hide()
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadSettings () {
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.getSettingRecord = data.enableMandatoryCustomerKyc
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('disbursement?all=all&status=pending&searchTerm=group', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //       _.forEach(this.rows, function (row, key) {
    //         this.totalAmt += parseInt(JSON.parse(row.plan).amount)
    //       }.bind(this))
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  },

  created () {
    // this.loadMember()
    this.loadSettings()
    this.changeFilter()
    var c = JSON.parse(localStorage.user)
    if (c.type === 'admin') {
      this.loadBranch()
    }
    this.loadLoan()
    this.loadPurpose()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  @media print {
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// GroupLoan.vue?57612550